import { Button } from "@material-ui/core";
import { theme } from "config/theme";
import { COLORS } from "constants/colors";
import styled from "styled-components";

interface CatalogStylesProps {
  wrap?: string;
}

export const ContainerProduct = styled("div")<CatalogStylesProps>`
  display: flex;
  width: 100%;
   flex-flow: ${({ wrap }) => (wrap ? "wrap" : "column")};
  ${theme.breakpoints.down("xs")} {
    flex-flow: column;
  }
`;
export const ProductListHeader = styled("div")`
  width: 100%;
  background: ${COLORS.lightBlue};
  border-color: ${COLORS.lightBlue};
  height: 50px;
  margin-bottom: 10px;
  padding: 15px 0;
  border-radius: 10px;
`;

export const CardProduct = styled("div")`
  width: 100%;
  padding: 10px;
  display: flex;
  margin-top: 5px;
  border: 1px solid ${COLORS.lightBlue};
  height: 50px;
  border-radius: 10px;
  font-weight: bold;

`;

export const ImageProduct = styled("div")``;

export const CardImageProduct = styled("span")`
  width: 30px;
  border-radius: 7px;
  position: relative;
  display: inline-block;
  margin-right: 15px;
  border: 1px solid #ececec;
`;

export const FillImageProduct = styled("img")`
  width: 100%;
  border-radius: 7px;
  position: absolute;
  top: 0px;
`;

export const DetailsProduct = styled("div")`
  display: block;
  margin: 0px 0px 0px 15px;
`;

export const NameProduct = styled("div")`
  color: #757a93;
  font-size: 16px;
  font-weight: bold;
  height: 33%;
`;

export const DescriptionProduct = styled("div")`
  color: #878787;
  font-size: 13px;
  height: 34%;
  display: flex;
  align-items: center;
`;

export const FooterProduct = styled("div")`
  display: flex;
  height: 33%;
`;

export const ItemFooterProduct = styled("div")`
  color: #5a525b;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  font-size: 12px;
`;

export const ValueItemFooterProduct = styled("span")`
  margin: 0px 25px 0px 0px;
`;

export const ContainerCounterProduct = styled("div")`
  display: flex;
  margin: 0px 0px 0px 7px;
`;

export const DescriptionProductDetails = styled("div")`
  word-break: break-all;
  width: 160px;
  position: relative;
    bottom: 10px;
    left: 40px;
`;

export const ContainerAddButtonArticle = styled("div")`
  width: 100%;
  text-align: left;
  ${theme.breakpoints.down("xs")} {
    margin-left: 0px;
    width: 100%;
  }
`;

export const TitleButton = styled("span")`
  color: #399dbe;
  font-size: 13px;
  font-weight: bold;
  margin-left: 5px;
  ${theme.breakpoints.down("xs")} {
    font-size: 10px;
    right: 18px;
    position: relative;
  }
`;

export const LineSeparator = styled("hr")`
  background-color: #efeded;
  border: 0.5px solid #efeded;
`;

export const ContainerProductDetails = styled("div")`
  display: flex;
  width: 100%;
  flex-flow: wrap;
  padding: 10px;
`;

export const CardProductDetails = styled("div")`
  width: 50%;
  padding: 1% 0% 3% 0%;
  display: flex;
`;

export const RecapStop = styled("div")`
  margin: 10px 0px 10px 9px;
  display: flex;
  align-items: center;
`;

export const AddressStop = styled("div")`
  margin: 0px 0px 0px 10px;
  color: #878787;
`;
